import React from 'react'
import { styled, useTheme } from '@mui/material/styles'
import { Box, Card, Icon, Popover } from '@mui/material'
import { Colorize } from '@mui/icons-material'
import { ChromePicker } from 'react-color'
import update from 'immutability-helper'
import { decideForeColor } from '../lib/util'
import { COLORS } from '../lib/color'
import './ColorSelector.scss'

const ColorPickerCard = styled(Card)(
  ({ theme }) => `
  .color-panel-box-border {
    border-color: ${theme.palette.text.primary};
  }
`
)

const ColorPicker = ({ value, onChange }) => {
  const theme = useTheme()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const changeIndex = index => {
    onChange(update(value, { index: { $set: index } }))
  }

  const clickCustom = evt => {
    changeIndex(-1)
    setAnchorEl(evt.currentTarget)
  }

  const changeCustom = color => {
    onChange(update(value, { custom: { $set: color.hex } }))
  }

  const panelBox = (color, index) => {
    const style = {
      backgroundColor: color,
      borderColor: value.index === index ? theme.palette.text.primary : color
    }

    return (
      <Box key={color}
           className="color-panel-box-border">
        <Box className="color-panel-box" sx={style}
             onClick={() => changeIndex(index)} />
      </Box>
    )
  }

  const customStyle = {
    color: decideForeColor(value.custom),
    backgroundColor: value.custom,
    borderColor: value.index < 0 ? theme.palette.text.primary : value.custom
  }

  return (
    <ColorPickerCard className="color-selector">
      {COLORS.map(panelBox)}
      <Box className="color-panel-box-border">
        <Box className="color-panel-box" sx={customStyle}
             onClick={clickCustom}>
          <Icon fontSize="small">
            <Colorize />
          </Icon>
        </Box>
      </Box>
      <Popover open={open}
               anchorEl={anchorEl}
               anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
               onClose={() => setAnchorEl(null)}>
        <ChromePicker disableAlpha={false}
                      color={value.custom}
                      onChange={changeCustom} />
      </Popover>
    </ColorPickerCard>
  )
}

export default ColorPicker
